/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ZocdocInsurancePlan } from "./ZocdocInsurancePlan";

export interface ZocdocInsurancePlansPage {
  plans: ZocdocInsurancePlan[];
  total: number;
  page: number;
  page_size: number;
}
